import request from '../utils/request.util'

export default {
  getList (params) {
    return request.get('/menus', { params })
  }
}
